import React from "react";

const MovieClubIcon = ({ className="" }) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g id="walk_of_fame" data-name="walk of fame" fill="currentColor"><path d="m30 13.33a1 1 0 0 0 -.81-.68l-8.46-1.23-3.83-7.67a1 1 0 0 0 -1.8 0l-3.78 7.67-8.46 1.23a1 1 0 0 0 -.56 1.7l6.13 6-1.43 8.4a1 1 0 0 0 .4 1 1 1 0 0 0 1 .07l7.57-4 7.57 4a1 1 0 0 0 .46.12 1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1l-1.45-8.43 6.13-6a1 1 0 0 0 .33-.99zm-8.2 5.93a1 1 0 0 0 -.29.88l1.2 7-6.24-3.28a1.06 1.06 0 0 0 -.94 0l-6.24 3.23 1.2-6.95a1 1 0 0 0 -.29-.88l-5-4.93 7-1a1 1 0 0 0 .75-.55l3.05-6.33 3.12 6.32a1 1 0 0 0 .75.55l7 1z"/><path d="m16 13a5 5 0 1 0 5 5 5 5 0 0 0 -5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1 -3 3z"/></g></svg>
    );
};

export default MovieClubIcon;
